/* eslint-disable jsx-a11y/no-interactive-element-to-noninteractive-role */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from '../../../../styles/general.module.scss';
import DriverDetail from './DriverDetail';

const UserList = (props) => {
  const { applications, handelApplication, savedOtp } = props;
  const { match: { params: { installationId } } } = props;
  const [viewDriver, setviewDriver] = useState({ useRecord: '', viewDetails: false });

  const getStatus = (ele) => {
    if (ele === 0) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Training Pending</div>;
    } if (ele === 1) {
      return <div style={{ background: '#6DD4001C', color: '#6DD400' }} className={styles.badge}>Pending Applicant Details</div>;
    } if (ele === 2) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Pending Approval</div>;
    } if (ele === 3) {
      return <div style={{ background: '#6DD4001C', color: '#6DD400' }} className={styles.badge}>Approved</div>;
    } if (ele === 4) {
      return <div style={{ background: '#F5515F22', color: '#F5515F' }} className={styles.badge}>Rejected</div>;
    } if (ele === 5) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Expired</div>;
    } if (ele === 8) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Suspended</div>;
    } if (ele === 11) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Pending Scheduling</div>;
    } return null;
  };

  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      {viewDriver?.viewDetails
        ? (
          <DriverDetail
            handleBackList={() => setviewDriver(({ ...viewDriver, viewDetails: false }))}
            driverRecord={viewDriver?.useRecord}
            savedOtp={savedOtp}
            installationId={installationId}
          />
)
        : <>
          <h3 style={{ color: 'white', marginLeft: '13%', marginTop: '3%' }}>Applications</h3>
          <table className={styles.table} style={{ margin: 'auto', marginBottom: '3%', width: '75%' }}>
            <thead>
              <tr style={{ background: 'rgb(233,239,244)', whiteSpace: 'pre' }}>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="First Name" />
                </th>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Company" />
                </th>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Status" />
                </th>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Action" />
                </th>
                <th>
                  {''}
                </th>
              </tr>
            </thead>
            <tbody>
              {applications.map(ele => (
                <tr>
                  <td style={{ color: 'rgba(50, 51, 102, 1)' }}>{`${ele.first_name} ${ele.last_name}`}</td>
                  <td style={{ color: 'rgba(50, 51, 102, 1)' }}>{ele.company}</td>
                  <td style={{ color: 'rgba(50, 51, 102, 1)' }}>{getStatus(ele?.status)}</td>
                  <td role="presentation">
                    {(ele?.status === 0 || ele.status === 1 || (ele.status === 11 && ele.scheduleEnable
                    && (ele.calendar_visibility === 'both' || ele.calendar_visibility === 'driver'))
                    || (ele?.status === 8
                        && ele.suspended_training_status !== 'Completed'
                        && ele.suspended_training_status !== 'Not Required'
                        && !ele.disable_driver_permit_online_training))
                      ? <button className={styles.btn} type="button" onClick={() => { handelApplication(ele); }}>
                        {ele?.status === 8
                        ? <FormattedMessage
                           id="adp.list.table.retake.view"
                           defaultMessage="Retake"
                          />
                        : <FormattedMessage
                            id="training.start.training"
                            defaultMessage="Start"
                          />
                        }
                        </button>
                      : (
                        <div style={{ marginLeft: '14px', cursor: 'pointer' }}
                          role="presentation"
                          onClick={() => setviewDriver(({ ...viewDriver, viewDetails: true, useRecord: ele }))}
                        >
                          <FormattedMessage
                            id="inspections.list.table.view"
                            defaultMessage="View"
                          />
                        </div>)
                    }
                  </td>
                  <td>
                    {ele.saved_as_draft && (
                      <div style={{
                        width: '49px',
                        borderRadius: '13px',
                        padding: '5px 8px',
                        background: '#E6EAEE',
                        color: '#8C9EA7'
                      }}
                      >
                        <FormattedMessage
                          id="inspections.step0.draft"
                          defaultMessage="Draft"
                        />
                      </div>)
                        }
                  </td>
                </tr>))}
            </tbody>
          </table>
          </>
}
    </div>
  );
};
export default UserList;
